import { BaseSqlFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/sql-base.adapter';
import { Dataset, DataFlowDSLAdapterRegistry, LinkedService, Metamodel, Owned } from 'shell-models-lib';
import { SqlMISettings } from 'app/model/dataflow/dataset-settings/sql-mi-settings';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetUtils } from 'app/model/dataset/dataset.utils';
import { DatasetFormatType, DataFlowDatasetSettings } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowAdapterUtils } from '../adapter.util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlMISettings)
})
export class SqlMIFormatAdapter extends BaseSqlFormatAdapter {
    /**
     * Supplements missing DSL properties for Fabric Migration.
     */
    public supplementPropsForFabricMigration(dataset: Dataset | undefined, linkedService: LinkedService | undefined, props: string[], isSource: boolean, isInline: boolean, _datasetSettings: DataFlowDatasetSettings | undefined, format?: string): void {
        if (linkedService) {
            const dbName = DatasetUtils.getDatabaseFromLinkedService(linkedService);
            if (dbName) {
                props.push(`database: ${DataFlowAdapterUtils.formatExpressionValue(dbName)}`);
            }
        }

        if (isInline || !dataset) {
            return;
        }

        props.push(`store: '${DatasetFormatType.SqlDB}'`);

        DataFlowAdapterUtils.supplementSqlSchemaAndTableFromDataset(dataset, props, isSource, format);
    }

    protected async toSourceDSL(sqlMISettings: SqlMISettings): Promise<string[]> {
        return super.toSourceDSL(sqlMISettings);
    }

    protected async toSinkDSL(sqlMISettings: SqlMISettings): Promise<string[]> {
        return super.toSinkDSL(sqlMISettings);
    }

    protected async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SqlMISettings> {
        const sqlMISettings = Owned.create<SqlMISettings>(SqlMISettings.MODEL, owner);
        sqlMISettings.initialize(undefined);
        await super.toSourceModel(owner, configs, handledConfigs, sqlMISettings);
        return sqlMISettings;
    }

    protected async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SqlMISettings> {
        const sqlMISettings = Owned.create<SqlMISettings>(SqlMISettings.MODEL, owner);
        sqlMISettings.initialize(undefined);
        await super.toSinkModel(owner, configs, handledConfigs, sqlMISettings);
        return sqlMISettings;
    }
}
